module.exports = __webpack_public_path__ + "static/media/6.12c821e8.jpg";